export const AUTH_TOKEN_NAME = 'AIToken';
export const AUTH_DEMO_INFO = 'AICreds';
export const IS_AUTHORIZED_COOKIE_NAME = 'AIAuth';

export const AUTH_TOKEN_EXPIRY = 400 * 24 * 60 * 60 * 1000; //400 days
export const AUTH_DEMO_TOKEN_EXPIRY = 30 * 24 * 60 * 60 * 1000; //30 days

export const QUERY_AUTH_PARAM_NAME = 'auth';
export const QUERY_TOKEN_PARAM_NAME = 'token';
